"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Configuration = _interopRequireDefault(require("./Configuration"));
var _ConfigHelper = require("./ConfigHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const curUrl = typeof window !== 'undefined' ? window.location.host : 'dev';
const ENV = (0, _ConfigHelper.GetEnviroment)(curUrl).env;
function getConfigEnv(env = ENV) {
  let conf;
  switch (env) {
    case 'LOCAL':
    case 'DEV':
      conf = _Configuration.default.dev;
      break;
    case 'STAGING':
      conf = _Configuration.default.staging;
      break;
    default:
      conf = _Configuration.default.production;
      break;
  }
  return conf;
}
var _default = exports.default = getConfigEnv;